import { useEffect, useState } from "react";
import supabase from "../supabase";

export const useAccount = () => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        // Get authenticated user
        const { data: userData, error: userError } = await supabase.auth
          .getUser();
        if (userError) throw userError;

        if (userData?.user) {
          setUser(userData.user);

          // Check if user is admin
          const { data: adminData, error: adminError } = await supabase
            .from("admin_users")
            .select("id")
            .eq("id", userData.user.id)
            .single();

          // Allow admin access on localhost for development
          const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
          setIsAdmin(!!adminData && !adminError || isLocalhost);

          // Fetch user profile data from profiles table
          const { data: profileData, error: profileError } = await supabase
            .from("user_profiles")
            .select("*")
            .eq("id", userData.user.id)
            .single();

          if (!profileError) {
            setProfile(profileData);
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();

    // Set up auth state listener
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === "SIGNED_OUT") {
          setUser(null);
          setProfile(null);
          setIsAdmin(false);
        }
      },
    );

    return () => {
      if (authListener?.subscription) {
        authListener.subscription.unsubscribe();
      }
    };
  }, []);

  return { user, profile, loading, isAdmin };
};

export default useAccount;
